import { Box, Text } from '@wix/design-system';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import React from 'react';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { SearchedDomainBrokerDataHooks } from './dataHooks';
export const BrokerFeePrice = _ref => {
  let align = _ref.align;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const _DomainsApiClient$hoo = DomainsApiClient.hooks.useGetBrokerFeePrice({}, true, {
      useErrorBoundary: false
    }),
    data = _DomainsApiClient$hoo.data;
  if (!(data != null && data.formattedPrice)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    align: align,
    dataHook: SearchedDomainBrokerDataHooks.feePrice
  }, /*#__PURE__*/React.createElement(Text, {
    size: "small",
    weight: "normal"
  }, data.formattedPrice), /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "normal"
  }, t('domain_search_gate.results.searched_domain.status.broker.fee_label')));
};
//# sourceMappingURL=BrokerFeePrice.js.map